<div class="input-daterange input-group container-datepicker" #inputDateRange>
    <div class="input-group-prepend">
        <span class="input-group-text">
            De
        </span>
    </div>

    <input type="text" 
           class="form-control text-center input-datepicker-start"
           #inputDateStart
           (keyup)="onKeyupDateStart($event)"
           (blur)="onBlurDateStart(inputDateStart.value)"
           [required]="required"
           [disabled]="disabled"
           [readonly]="readonly">

    <div class="input-group-prepend">
        <span class="input-group-text">
            Até
        </span>
    </div>

    <input type="text" 
           class="form-control text-center input-datepicker-end"
           #inputDateEnd
           (keyup)="onKeyupDateEnd($event)"
           (blur)="onBlurDateEnd(inputDateEnd.value)"
           [required]="required"
           [disabled]="disabled"
           [readonly]="readonly">
</div>